// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"styles_animationWrapper__rxdZ_","hideAnimation":"styles_hideAnimation__4e_a9"};